<template>
	 <div class="allWhole">
	 	<div class="header">
	 		<div class="left">
	 			<img src="../../img/p1.png" style="width:70%"/>
	 		</div>
	 		
	 		<div class="right">
	 			<ul>
	 				<li><a href="#1" rel="external nofollow">项目优势</a></li>
	 				<li><a href="#2" rel="external nofollow">院校实力</a></li>
	 				<li><a href="#3" rel="external nofollow">提升方案</a></li>
	 				<li><a href="#4" rel="external nofollow">师资力量</a></li>
	 				<li><a href="#5" rel="external nofollow">学习方式</a></li>
	 				<li><a href="#6" rel="external nofollow">学员情况</a></li>
	 				<li><a href="#7" rel="external nofollow">媒体报道</a></li>
	 			</ul>
	 		</div>
	 	</div>
	 	
	 	<div>
	 		<a id="1"><img src="../../img/p2.png" style="width:100%"/></a>
	 	</div>
	 	
	 	<div>
	 		<a id="2"><img src="../../img/p3.jpg" style="width:100%"/></a>
	 	</div>
	 	
	 	<div>
	 		<a id="3"><img src="../../img/p4.png" style="width:100%"/></a>
	 	</div>
	 	
	 	<div>
	 		<a id="4"><img src="../../img/p5.jpg" style="width:100%"/></a>
	 	</div>
	 	
	 	<div>
	 		<a id="5"><img src="../../img/p6.jpg" style="width:100%"/></a>
	 	</div>
	 	
	 	<div>
	 		<a id="6"><img src="../../img/p7.jpg" style="width:100%"/></a>
	 	</div>
	 	
	 	<div style="margin-top:-10px">
	 		<a id="7"><img src="../../img/p8.jpg" style="width:100%"/></a>
	 	</div>
	 	
	 	<div style="margin-top:-10px">
	 		<img src="../../img/p9.jpg" style="width:100%"/>
	 	</div>
	 	<div class="blue">
	 		
	 	</div>
	 	<div class="bottom">
	 		<form action="" ref="formData" class="form">
				<span class="u-item">
					<span class="name">姓名:</span>
					<input type="text" class="input" v-model="formData.name">
				</span>
	
				<span class="u-item">
					<span class="name">联系方式:</span>
					<input type="tel" v-validate="'required|isMobile'" data-vv-name="手机号码" :class="colorShow?'input':'input yellow-border'" v-model="formData.mobile" ref="mobileInput" @blur="mobileBlur">
				</span>
	
				<span class="u-item">
					<span class="name">验证码:</span>
					<span class="clearfix" style="height:45px;line-height:56px;width: 100%;">
						<input type="tel" class="input" style="width:6%;margin-right:2px" v-validate="'required'" data-vv-name="验证码" v-model="mobileCode" ref="codeInput">
						<span class="code" @click="getCode">{{ verificationCode }}</span>
					</span>
				</span>
				
				<span class="submit" @click="saveAllInfo">免费获取6800元试听课</span>
			</form>
	 	</div>
	</div>
</template>

<script>
	import { getInsert, getTradeList, getAreaList, getCountList, advertisersCallback, getCodeFun, getVerifyCode } from "./apis.js";
	export default {
		name: "Index",
		data() {
			return {
				formData: {
					name: '',
					mobile: '',
					area: '',
					trade: '',
					channelCode: this.$route.query.channelCode
				},
				areaProvinceList: [],
				areaList: [],
				areaCityList: [],
				tradeList: [], //所属行业
				areaProvinceId: '',
				areaCityId: '',
				province: '',
				city: '',
				colorShow: true,
				count:'',
				pValue:'',
				status: true,
				timer: 60,
				verificationCode: "获取短信验证码",
				codeFocus:false,
				mobileCode: '' //短信验证码
			};
		},
		methods: {
			getCode() {	
				if(this.formData.mobile == ""){
					this.$layer.msg("手机号码不能为空", {time: 3});
					this.$refs.mobileInput.focus();
				}else{
					if(this.errors.items.length != 0 && this.errors.items[0].field == "手机号码") {
						this.$layer.msg(this.errors.items[0].msg, {time: 3});
						this.$refs.mobileInput.focus();
						this.colorShow = false;
						return;
					}
					if(this.status) {	
						this.status = false;
						var count = this.timer;
						this.verificationCode = count + "s后重新获取";
						var timer = setInterval(() => {
							if(count === 0) {
								clearInterval(timer);
								this.verificationCode = "获取验证码";
								this.status = true;
							} else {
								count--;
								this.verificationCode = count + "s后重新获取";
							}
						}, 1000);
						this.$refs.codeInput.focus();
						this.getSmsCode();
					}
				}
			},
			async getSmsCode(){//获取验证码
				try {
					let param = {
						"mobile": this.formData.mobile
					}
					let {data} = await getCodeFun(param);
					if(data.code == 1000){
						this.$layer.msg(data.message, {time: 3});
					}
				} catch(err) {
					console.log(err);
				}
			},
			async getVerifyCode(){//验证短信验证码是否正确
				try {
					let param = {
						"mobile": this.formData.mobile,
						"mobileCode": this.mobileCode
					}
					let {data} = await getVerifyCode(param);
					if(data.code == 1000){
						console.log("验证短信验证码", data);
//						this.$layer.msg(data.message, {time: 3});
						this.saveInfo();
					}else{
						this.$layer.msg(data.message, {time: 3});
					}
				} catch(err) {
					console.log(err);
				}
			},
			async saveInfo() { //保存
				try {
					if(this.formData.name == " ") {
						this.formData.name = ""
					}
					let {data} = await getInsert(this.formData);
					if(data.code == 1000){
						console.log("保存接口返回的数据", data);
						this.$layer.msg(data.message, {time: 3});
						this.advertisersCallback();
					}else{
						this.$layer.msg(data.message, {time: 3});
//						this.advertisersCallback();
					}
				} catch(err) {
					console.log(err);
				}
			},
			async advertisersCallback() { //广告回调
				try {
					let params = {
						p:this.pValue
					}
					let {data} = await advertisersCallback(params);
					console.log("广告回调返回数据", data);
				} catch(err) {
					console.log(err);
				}
			},
			saveAllInfo() {
				this.$validator.validateAll().then((res) => {
					if(res) {
//						this.saveInfo();
						this.getVerifyCode();
						return
					}
					if(this.errors.items[0].rule == 'required') {
						this.$layer.msg(`${this.errors.items[0].field}不能为空`, {time: 3});
						this.$refs.mobileInput.focus();
						this.colorShow = false;
						return
					}
					if(this.errors.items.length != 0 && this.errors.items[0].field == "手机号码") {
						this.$layer.msg(this.errors.items[0].msg, {time: 3});
						this.$refs.mobileInput.focus();
						this.colorShow = false;
						return;
					}
				})
			},
			async getTradeList() {
				let params = {
					dictType: "trade_detail",
					pageSize: "10000"
				}
				try {
					let {data} = await getTradeList(params);
					console.log("所属行业数据", data);
					this.tradeList = data.data.content;
				} catch(err) {
					console.log(err);
				}
			},
			async getCountList(){//获取人数
				try {
					let {data} = await getCountList();
					console.log("人数",data);
					this.count = data.data;
				} catch(err) {
					console.log(err);
				}
			},
			mobileBlur() {//手机号码input失焦事件
				this.colorShow = true;
			},
			async getAreaList() { //获取所在城市
				let parentAreaId = "";
				if(this.province != '' && this.city == "") {
					parentAreaId = this.areaProvinceId;
				} else if(this.province != '' && this.city != "") {
					parentAreaId = this.areaCityId;
				} else {
					parentAreaId = ""
				}
				let params = {
					parentAreaId: parentAreaId,
					pageSize: "10000"
				}
				try {
					let {
						data
					} = await getAreaList(params);
					console.log("获取城市数据", data);
					if(parentAreaId != "" && this.areaCityId == "") {
						this.areaCityList = data.data.content; //获取市
					} else if(parentAreaId != "" && this.areaCityId != "") {
						this.areaList = data.data.content; //获取县
					} else {
						this.areaProvinceList = data.data.content; //获取省
					}
				} catch(err) {
					console.log(err);
				}
			}
		},
		watch: {
			"province": {
				handler: function(val) {
					console.log("val", val);
					this.areaProvinceId = val;
					this.city = "";
					this.formData.area = "";
					this.getAreaList();
				}
			},
			"city": {
				handler: function(val) {
					console.log("val", val);
					this.areaCityId = val;
					this.formData.area = "";
					this.getAreaList();
				}
			}
		},
		mounted() {
			this.getCountList();
			this.getAreaList();
			this.getTradeList();
			this.pValue=this.$route.query.p;
			console.log("this.pValue",this.pValue)
		}
	};
</script>


<style>
	*{
		padding:0;
		margin:0;
		list-style:none;
		
	}
	a{
		color:#666666;
		text-decoration: none;
	}
	.header{
		width:1000px;
		margin:0 auto;
		height:96px;
	}
	.left{
		float:left;
	}
	.left img{
		margin-top:16px;
	}
	.right{
		float:right;
	}
	.right ul li{
		width:80px;
		float:left;
		font-size:12px;
		line-height:96px;
		color:#000000;
	}
	.bottom{
		background:#5592d7;
		height:78px;
		margin-top:-10px;
		color:#fff;
		line-height:78px;
		font-size:12px;
		padding-top:10px;
		position:fixed;
		z-index:1000;
		bottom:0;
		width:100%;
	}
	.input{
		width:9%;
		height:25px;
		padding-left:10px;
		margin-right:15px;
	}
	.submit{
		width:180px;
		height:40px;
		background:#fff100;
		color:#000000;
		display:inline-block;
		line-height:40px;
		font-weight:bold;
		font-size:16px;
	}
	.submit:hover{
		cursor:pointer;
	}
	.code{
		width:8%;
		height:28px;
		background:#fff;
		color:#5592d7;
	    display:inline-block;
	    line-height:28px;
	    font-size:12px;
	    margin-right:15px;
	    vertical-align:middle;
	}
	.code:hover{
		cursor:pointer;
	}
	.blue{
		height:84px;
		width:100%;
		background:#5592d7;
	}
</style>


// WEBPACK FOOTER //
// src/pages/pc/index.vue